import { GetSubjectsVariablesArgs } from '@modules/timetable';

export const getSubjectsVariables = ({ batchId, semesterId }: GetSubjectsVariablesArgs) => {
  return {
    variables: {
      batchSubjectWhere: {
        batchId: {
          _eq: batchId || '',
        },
        subject: {
          course_semester_subjects_subjects: {
            course_semester: {
              semester: {
                _eq: semesterId || '',
              },
            },
          },
          subject_to_users: {
            userId: {
              _is_null: false,
            },
          },
        },
      },
      userWhere: {
        user: {
          active: {
            _eq: true,
          },
        },
      },
    },
  };
};
